/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum JurisdictionType {
    COUNTRY_ONLY = 'COUNTRY_ONLY',
    COUNTRY_AND_SUBDIVISION = 'COUNTRY_AND_SUBDIVISION',
}
